import { Modal, Button, Input, Form, Row } from 'antd'
import { useMutation } from 'react-query'
import {
  saveInspectionType,
  updateInspectionType,
} from '../../../DataManagement.transform'
import './ModalAddNewInspectionType.style.less'
import { useEffect } from 'react'
import { isEmptyValue } from '@/utils/common'
import useMasterData from '@/hook/MasterData'
import { queryClient } from '@/config/react-query'

interface Props {
  visible: boolean
  onClose: () => void
  data?: any
  propertyId: string
}

function ModalAddNewInspectionType(props: Props) {
  const [form] = Form.useForm()

  const { refetch } = useMasterData()

  const mutation = useMutation(async (data: any) => {
    await saveInspectionType(props.propertyId, data)
  })

  const updateMutation = useMutation(async (data: any) => {
    await updateInspectionType(props.data.id, data)
  })

  useEffect(() => {
    if (!isEmptyValue(props.data)) {
      form.setFieldsValue({
        name: props.data.name,
        acronym: props.data.acronym,
      })
    }
  }, [props.data])

  const onSave = async (values) => {
    const data = {
      name: values.name,
      acronym: values.acronym,
    }
    if (!isEmptyValue(props.data)) {
      await updateMutation.mutateAsync(data)
    } else {
      await mutation.mutateAsync(data)
    }
    await refetch()
    await queryClient.refetchQueries(['inspectionType'])
    props.onClose()
  }

  return (
    <Modal
      className="modal-add-supplier-container"
      open={props.visible}
      onCancel={props.onClose}
      centered
      width={480}
      footer={false}
      maskClosable={false}
    >
      <p className="title">
        {!isEmptyValue(props.data) ? 'Edit' : 'New'} Inspection Type
      </p>
      <Form
        onFinish={onSave}
        form={form}
        initialValues={{}}
        labelCol={{ span: 7 }}
      >
        <Form.Item
          name="name"
          label="Name"
          rules={[{ required: true, message: 'This Fields required' }]}
        >
          <Input size="large" placeholder="Text" />
        </Form.Item>
        <Form.Item
          name="acronym"
          label="Acronym"
          rules={[{ required: true, message: 'This Fields required' }]}
        >
          <Input size="large" placeholder="Text" />
        </Form.Item>
        <Row className="button-container">
          <Button size="large" onClick={props.onClose}>
            Cancel
          </Button>
          <Button
            loading={mutation.isLoading || updateMutation.isLoading}
            size="large"
            type="primary"
            htmlType="submit"
          >
            {!isEmptyValue(props.data) ? 'Save' : 'Create'}
          </Button>
        </Row>
      </Form>
    </Modal>
  )
}

export default ModalAddNewInspectionType
